var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1131px",
    height: "252px",
    viewBox: "0 0 1131 252",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FF72B552-6F5A-412A-8AD0-2A9F919277B4@0.50x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 1134.62491 0 1134.62491 400 0 400"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "D\\xE9l\\xE9gation-Droits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.1---SUPER-ADMIN---Pattern-notification---Plus-d'elements",
    transform: "translate(-153.000000, -772.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-town",
    transform: "translate(153.000000, 624.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#E1E2E1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.577859, 148.707647)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "8.68987618 31.7319738 53.803059 31.7319738 53.803059 14.377276 8.68987618 14.377276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1810634,4.68171886 C48.0224326,4.68171886 51.9469774,8.60597232 51.9469774,13.4479243 C51.9469774,18.2869629 48.0224326,22.2141296 43.1810634,22.2141296 C38.3402768,22.2141296 34.4160233,18.2869629 34.4160233,13.4479243 C34.4160233,8.60597232 38.3402768,4.68171886 43.1810634,4.68171886 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68987618,14.377276 C8.68987618,6.43554261 15.1268755,-4.79616347e-14 23.0668609,-4.79616347e-14 C31.007429,-4.79616347e-14 37.4444283,6.43554261 37.4444283,14.377276 C37.4444283,22.3190095 31.007429,28.7545521 23.0668609,28.7545521 C15.1268755,28.7545521 8.68987618,22.3190095 8.68987618,14.377276",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1120175,23.0677349 C45.1120175,18.2665696 49.003059,14.377276 53.803059,14.377276 C58.602185,14.377276 62.4926438,18.2665696 62.4926438,23.0677349 C62.4926438,27.8659869 58.602185,31.7581937 53.803059,31.7581937 C49.003059,31.7581937 45.1120175,27.8659869 45.1120175,23.0677349",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.37507799e-14,23.0677349 C-3.37507799e-14,18.2665696 3.89016752,14.377276 8.68987618,14.377276 C13.4892935,14.377276 17.379461,18.2665696 17.379461,23.0677349 C17.379461,27.8659869 13.4892935,31.7581937 8.68987618,31.7581937 C3.89016752,31.7581937 -3.37507799e-14,27.8659869 -3.37507799e-14,23.0677349",
    id: "Fill-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)",
    fill: "#E1E2E1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(603.015295, 189.600583)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "8.69045885 31.7319738 53.800437 31.7319738 53.800437 14.3801894 8.69045885 14.3801894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4151493,13.4479243 C34.4151493,8.60597232 38.3394028,4.68171886 43.1813547,4.68171886 C48.0203933,4.68171886 51.9475601,8.60597232 51.9475601,13.4479243 C51.9475601,18.2898762 48.0203933,22.2141296 43.1813547,22.2141296 C38.3394028,22.2141296 34.4151493,18.2898762 34.4151493,13.4479243",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69045885,14.3801894 C8.69045885,6.43845594 15.1260015,3.73034936e-14 23.0648216,3.73034936e-14 C31.006555,3.73034936e-14 37.4450109,6.43845594 37.4450109,14.3801894 C37.4450109,22.3190095 31.006555,28.7574654 23.0648216,28.7574654 C15.1260015,28.7574654 8.69045885,22.3190095 8.69045885,14.3801894",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1128915,23.0677349 C45.1128915,18.2694829 49.002185,14.3801894 53.800437,14.3801894 C58.6016023,14.3801894 62.4908958,18.2694829 62.4908958,23.0677349 C62.4908958,27.8689002 58.6016023,31.7581937 53.800437,31.7581937 C49.002185,31.7581937 45.1128915,27.8689002 45.1128915,23.0677349",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52766688e-13,23.0677349 C1.52766688e-13,18.2694829 3.88929352,14.3801894 8.69045885,14.3801894 C13.4887109,14.3801894 17.3780044,18.2694829 17.3780044,23.0677349 C17.3780044,27.8689002 13.4887109,31.7581937 8.69045885,31.7581937 C3.88929352,31.7581937 1.52766688e-13,27.8689002 1.52766688e-13,23.0677349",
    id: "Fill-11"
  }))), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-36",
    fill: "#54274B",
    mask: "url(#mask-2)",
    points: "185.44705 395.140277 184.192862 400.017189 172.897888 399.958922 174.337655 395.140277 185.44705 395.140277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.99024,375.988055 C262.99024,375.988055 258.783977,376.669774 256.974508,379.609323 C259.00976,385.264093 259.980772,399.958922 259.980772,399.958922 L261.949017,399.958922 L262.99024,375.988055",
    id: "Fill-39",
    fill: "#54274B",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-40",
    fill: "#54274B",
    mask: "url(#mask-2)",
    points: "267.375382 399.958922 280.756883 399.958922 267.65244 394.295412 267.375382 399.958922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.918427,389.456373 C874.691916,391.807429 868.273853,393.30488 863.583394,392.602768 C859.72906,392.037582 854.601602,396.206555 861.229425,398.423598 C869.445011,401.167953 877.876184,400.177422 880.448653,396.908667 C880.445739,398.213838 880.439913,399.708376 880.439913,399.708376 L890.712309,399.711289 L889.643117,389.456373 L875.918427,389.456373",
    id: "Fill-75",
    fill: "#54274B",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.261471,389.135907 C963.99126,391.460743 957.541151,392.821267 952.865259,392.020102 C949.019665,391.367516 943.801894,395.428696 950.394756,397.788492 C958.546249,400.710561 966.989075,399.897742 969.634377,396.684341 C969.605244,397.995339 969.573197,399.48405 969.573197,399.48405 L979.831027,399.708376 L978.983248,389.430153 L965.261471,389.135907",
    id: "Fill-76",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.613984,381.878806 L297.963583,381.878806 L297.963583,376.445448 L293.613984,376.445448 L293.613984,381.878806 Z M284.804079,381.878806 L289.152513,381.878806 L289.152513,376.445448 L284.804079,376.445448 L284.804079,381.878806 Z M277.937072,372.168682 L273.588055,372.168682 L273.588055,366.738237 L277.935615,366.735324 L277.937072,372.168682 Z M264.778733,372.168682 L269.126875,372.168682 L269.126875,366.735324 L264.778733,366.735324 L264.778733,372.168682 Z M260.318135,372.168682 L255.969993,372.168682 L255.969993,366.735324 L260.317553,366.735324 L260.318135,372.168682 Z M247.16067,372.168682 L251.508521,372.168682 L251.508521,366.735324 L247.16067,366.735324 L247.16067,372.168682 Z M236.609177,381.878806 L232.260743,381.878806 L232.261617,376.445448 L236.609177,376.445448 L236.609177,381.878806 Z M227.800437,381.878806 L223.45142,381.878806 L223.45142,376.445448 L227.79898,376.445448 L227.800437,381.878806 Z M202.442535,400.017189 L310.936635,400.017189 L310.936635,360.011362 L202.442535,360.011362 L202.442535,400.017189 Z",
    id: "Fill-126",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-129",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "262.676766 360.011362 278.888274 360.011362 278.888274 355.119883 262.676766 355.119883"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-130",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "287.683613 360.011362 303.89512 360.011362 303.89512 355.119883 287.683613 355.119883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.19665,372.270648 L770.528769,372.270648 L770.528769,366.857684 L766.19665,366.857684 L766.19665,372.270648 Z M757.418791,372.270648 L761.75091,372.270648 L761.75091,366.857684 L757.418791,366.857684 L757.418791,372.270648 Z M748.640932,372.270648 L752.973052,372.270648 L752.973052,366.857684 L748.640932,366.857684 L748.640932,372.270648 Z M748.640932,381.945812 L752.973052,381.945812 L752.973052,376.532848 L748.640932,376.532848 L748.640932,381.945812 Z M739.865987,372.270648 L744.198106,372.270648 L744.198106,366.857684 L739.865987,366.857684 L739.865987,372.270648 Z M739.865987,381.945812 L744.198106,381.945812 L744.198106,376.532848 L739.865987,376.532848 L739.865987,381.945812 Z M647.329934,400.017189 L803.405681,400.017189 L803.405681,360.159942 L647.329934,360.159942 L647.329934,400.017189 Z",
    id: "Fill-160",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-161",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "679.079388 340.952367 679.079388 360.159942 694.957028 360.159942 679.079388 340.952367"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-162",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "694.957028 340.952367 694.957028 360.159942 710.831755 360.159942 694.957028 340.952367"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-163",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "710.831755 340.952367 710.831755 360.159942 726.706482 360.159942 710.831755 340.952367"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-164",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "647.329934 340.952367 647.329934 360.159942 663.204661 360.159942 647.329934 340.952367"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-165",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "663.204661 340.952367 663.204661 360.159942 679.082302 360.159942 663.204661 340.952367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-167",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "783.481428 360.159942 799.775674 360.159942 799.775674 356.695994 783.481428 356.695994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-168",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "577.800437 399.999709 622.400583 399.999709 622.400583 229.666133 577.800437 229.666133"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-169",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "583.775674 229.666133 616.428259 229.666133 616.428259 224.853314 583.775674 224.853314"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-170",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "589.310998 224.853314 610.895849 224.853314 610.895849 217.843846 589.310998 217.843846"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-171",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "593.042972 217.843846 607.160961 217.843846 607.160961 214.184705 593.042972 214.184705"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-172",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "583.775674 250.822724 586.211216 250.822724 586.211216 241.928332 583.775674 241.928332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-173",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "583.775674 270.496431 586.211216 270.496431 586.211216 261.604953 583.775674 261.604953"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-174",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "583.775674 290.173052 586.211216 290.173052 586.211216 281.27866 583.775674 281.27866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-175",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "583.775674 309.846759 586.211216 309.846759 586.211216 300.952367 583.775674 300.952367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-176",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "583.775674 329.520466 586.211216 329.520466 586.211216 320.628988 583.775674 320.628988"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-177",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "583.775674 349.194173 586.211216 349.194173 586.211216 340.302695 583.775674 340.302695"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-178",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "583.775674 368.870794 586.211216 368.870794 586.211216 359.976402 583.775674 359.976402"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-179",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "583.775674 388.544501 586.211216 388.544501 586.211216 379.650109 583.775674 379.650109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-180",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "588.093227 250.822724 590.528769 250.822724 590.528769 241.928332 588.093227 241.928332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-181",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "588.093227 270.496431 590.528769 270.496431 590.528769 261.604953 588.093227 261.604953"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-182",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "588.093227 290.173052 590.528769 290.173052 590.528769 281.27866 588.093227 281.27866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-183",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "588.093227 309.846759 590.528769 309.846759 590.528769 300.952367 588.093227 300.952367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-184",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "588.093227 329.520466 590.528769 329.520466 590.528769 320.628988 588.093227 320.628988"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-185",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "588.093227 349.194173 590.528769 349.194173 590.528769 340.302695 588.093227 340.302695"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-186",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "588.093227 368.870794 590.528769 368.870794 590.528769 359.976402 588.093227 359.976402"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-187",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "588.093227 388.544501 590.528769 388.544501 590.528769 379.650109 588.093227 379.650109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-188",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "596.725419 250.822724 599.160961 250.822724 599.160961 241.928332 596.725419 241.928332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-189",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "596.725419 270.496431 599.160961 270.496431 599.160961 261.604953 596.725419 261.604953"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-190",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "596.725419 290.173052 599.160961 290.173052 599.160961 281.27866 596.725419 281.27866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-191",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "596.725419 309.846759 599.160961 309.846759 599.160961 300.952367 596.725419 300.952367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-192",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "596.725419 329.520466 599.160961 329.520466 599.160961 320.628988 596.725419 320.628988"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-193",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "596.725419 349.194173 599.160961 349.194173 599.160961 340.302695 596.725419 340.302695"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-194",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "596.725419 368.870794 599.160961 368.870794 599.160961 359.976402 596.725419 359.976402"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-195",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "596.725419 388.544501 599.160961 388.544501 599.160961 379.650109 596.725419 379.650109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-196",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "601.042972 250.822724 603.475601 250.822724 603.475601 241.928332 601.042972 241.928332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-197",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "601.042972 270.496431 603.475601 270.496431 603.475601 261.604953 601.042972 261.604953"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-198",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "601.042972 290.173052 603.475601 290.173052 603.475601 281.27866 601.042972 281.27866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-199",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "601.042972 309.846759 603.475601 309.846759 603.475601 300.952367 601.042972 300.952367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-200",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "601.042972 329.520466 603.475601 329.520466 603.475601 320.628988 601.042972 320.628988"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-201",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "601.042972 349.194173 603.475601 349.194173 603.475601 340.302695 601.042972 340.302695"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-202",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "601.042972 368.870794 603.475601 368.870794 603.475601 359.976402 601.042972 359.976402"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-203",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "601.042972 388.544501 603.475601 388.544501 603.475601 379.650109 601.042972 379.650109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-204",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "609.675164 250.822724 612.107793 250.822724 612.107793 241.928332 609.675164 241.928332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-205",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "609.675164 270.496431 612.107793 270.496431 612.107793 261.604953 609.675164 261.604953"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-206",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "609.675164 290.173052 612.107793 290.173052 612.107793 281.27866 609.675164 281.27866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-207",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "609.675164 309.846759 612.107793 309.846759 612.107793 300.952367 609.675164 300.952367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-208",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "609.675164 329.520466 612.107793 329.520466 612.107793 320.628988 609.675164 320.628988"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-209",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "609.675164 349.194173 612.107793 349.194173 612.107793 340.302695 609.675164 340.302695"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-210",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "609.675164 368.870794 612.107793 368.870794 612.107793 359.976402 609.675164 359.976402"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-211",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "609.675164 388.544501 612.107793 388.544501 612.107793 379.650109 609.675164 379.650109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-212",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "613.989803 250.822724 616.428259 250.822724 616.428259 241.928332 613.989803 241.928332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-213",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "613.989803 270.496431 616.428259 270.496431 616.428259 261.604953 613.989803 261.604953"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-214",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "613.989803 290.173052 616.428259 290.173052 616.428259 281.27866 613.989803 281.27866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-215",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "613.989803 309.846759 616.428259 309.846759 616.428259 300.952367 613.989803 300.952367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-216",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "613.989803 329.520466 616.428259 329.520466 616.428259 320.628988 613.989803 320.628988"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-217",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "613.989803 349.194173 616.428259 349.194173 616.428259 340.302695 613.989803 340.302695"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-218",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "613.989803 368.870794 616.428259 368.870794 616.428259 359.976402 613.989803 359.976402"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-219",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "613.989803 388.544501 616.428259 388.544501 616.428259 379.650109 613.989803 379.650109"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-220",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "605.445011 214.184705 600.101966 200.725127 594.758922 214.184705 605.445011 214.184705"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-221",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "188.228988 211.973489 151.555717 211.973489 138.284341 234.880991 188.228988 234.880991 188.228988 211.973489"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-222",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "188.228988 211.973489 151.555717 211.973489 138.284341 234.880991 174.957902 234.880991 188.228988 211.973489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-223",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "187.637582 211.973489 174.366788 234.880991 174.957902 234.880991 188.228988 211.973489"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-224",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "182.215295 211.973489 181.624181 211.973489 168.353387 234.880991 168.943918 234.880991 182.215295 211.973489"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-225",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "176.20102 211.973489 175.610197 211.973489 162.339403 234.880991 162.930517 234.880991 176.20102 211.973489"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-226",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "170.187327 211.973489 169.596504 211.973489 156.32571 234.880991 156.917116 234.880991 170.187327 211.973489"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-227",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "164.173926 211.973489 163.583394 211.973489 150.312309 234.880991 150.903132 234.880991 164.173926 211.973489"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-228",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "158.160524 211.973489 157.569119 211.973489 144.298325 234.880991 144.889148 234.880991 158.160524 211.973489"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-229",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "152.14654 211.973489 151.555717 211.973489 138.284341 234.880991 138.875747 234.880991 152.14654 211.973489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-230",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 256.069629 138.284341 256.069629 138.284341 249.316533 134.867298 249.316533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-231",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 270.502258 138.284341 270.502258 138.284341 263.752076 134.867298 263.752076"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-232",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 284.9378 138.284341 284.9378 138.284341 278.184705 134.867298 278.184705"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-233",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 299.373343 138.284341 299.373343 138.284341 292.620248 134.867298 292.620248"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-234",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 313.808886 138.284341 313.808886 138.284341 307.05579 134.867298 307.05579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-235",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 328.241515 138.284341 328.241515 138.284341 321.491333 134.867298 321.491333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-236",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 342.677058 138.284341 342.677058 138.284341 335.923962 134.867298 335.923962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-237",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 357.1126 138.284341 357.1126 138.284341 350.359505 134.867298 350.359505"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-238",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "134.867298 371.548143 138.284341 371.548143 138.284341 364.795047 134.867298 364.795047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.82287,256.069629 L171.240204,256.069629 L171.240204,249.316533 L167.82287,249.316533 L167.82287,256.069629 Z M167.82287,270.502258 L171.240204,270.502258 L171.240204,263.752076 L167.82287,263.752076 L167.82287,270.502258 Z M167.82287,371.548143 L171.240204,371.548143 L171.240204,364.795047 L167.82287,364.795047 L167.82287,371.548143 Z M160.345229,256.069629 L163.762272,256.069629 L163.762272,249.316533 L160.345229,249.316533 L160.345229,256.069629 Z M160.345229,270.502258 L163.762272,270.502258 L163.762272,263.752076 L160.345229,263.752076 L160.345229,270.502258 Z M160.345229,284.9378 L163.762272,284.9378 L163.762272,278.184705 L160.345229,278.184705 L160.345229,284.9378 Z M160.345229,371.548143 L163.762272,371.548143 L163.762272,364.795047 L160.345229,364.795047 L160.345229,371.548143 Z M149.82287,256.069629 L153.239621,256.069629 L153.239621,249.316533 L149.82287,249.316533 L149.82287,256.069629 Z M149.82287,270.502258 L153.239621,270.502258 L153.239621,263.752076 L149.82287,263.752076 L149.82287,270.502258 Z M149.82287,284.9378 L153.239621,284.9378 L153.239621,278.184705 L149.82287,278.184705 L149.82287,284.9378 Z M149.82287,299.373343 L153.239621,299.373343 L153.239621,292.620248 L149.82287,292.620248 L149.82287,299.373343 Z M149.82287,313.808886 L153.239621,313.808886 L153.239621,307.05579 L149.82287,307.05579 L149.82287,313.808886 Z M149.82287,328.241515 L153.239621,328.241515 L153.239621,321.491333 L149.82287,321.491333 L149.82287,328.241515 Z M149.82287,342.677058 L153.239621,342.677058 L153.239621,335.923962 L149.82287,335.923962 L149.82287,342.677058 Z M149.82287,357.1126 L153.239621,357.1126 L153.239621,350.359505 L149.82287,350.359505 L149.82287,357.1126 Z M149.82287,371.548143 L153.239621,371.548143 L153.239621,364.795047 L149.82287,364.795047 L149.82287,371.548143 Z M142.345229,256.069629 L145.761981,256.069629 L145.761981,249.316533 L142.345229,249.316533 L142.345229,256.069629 Z M142.345229,270.502258 L145.761981,270.502258 L145.761981,263.752076 L142.345229,263.752076 L142.345229,270.502258 Z M142.345229,284.9378 L145.761981,284.9378 L145.761981,278.184705 L142.345229,278.184705 L142.345229,284.9378 Z M142.345229,299.373343 L145.761981,299.373343 L145.761981,292.620248 L142.345229,292.620248 L142.345229,299.373343 Z M142.345229,313.808886 L145.761981,313.808886 L145.761981,307.05579 L142.345229,307.05579 L142.345229,313.808886 Z M142.345229,328.241515 L145.761981,328.241515 L145.761981,321.491333 L142.345229,321.491333 L142.345229,328.241515 Z M142.345229,342.677058 L145.761981,342.677058 L145.761981,335.923962 L142.345229,335.923962 L142.345229,342.677058 Z M142.345229,357.1126 L145.761981,357.1126 L145.761981,350.359505 L142.345229,350.359505 L142.345229,357.1126 Z M142.345229,371.548143 L145.761981,371.548143 L145.761981,364.795047 L142.345229,364.795047 L142.345229,371.548143 Z M138.284341,400.017189 L188.228988,400.017189 L188.228988,234.880991 L138.284341,234.880991 L138.284341,400.017189 Z",
    id: "Fill-239",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-240",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "589.83831 399.999709 634.260743 399.999709 634.260743 338.846031 589.83831 338.846031"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-241",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "597.008012 399.999709 627.091042 399.999709 627.091042 387.921049 597.008012 387.921049"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-242",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "594.927895 378.691624 599.589221 378.691624 599.589221 344.588201 594.927895 344.588201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-243",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "604.873999 378.691624 609.532411 378.691624 609.532411 344.588201 604.873999 344.588201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-244",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "614.817189 378.691624 619.478514 378.691624 619.478514 344.588201 614.817189 344.588201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-245",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "624.760379 378.691624 629.421704 378.691624 629.421704 344.588201 624.760379 344.588201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-246",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "2.32745812 398.732411 59.9353241 398.732411 59.9353241 273.709832 2.32745812 273.709832"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-247",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "2.32745812 273.709832 59.9353241 273.709832 59.9353241 271.778296 2.32745812 271.778296"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-248",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "11.016169 271.778296 51.2451566 271.778296 51.2451566 266.342025 11.016169 266.342025"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-249",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "38.0658412 266.342025 47.4747269 266.342025 47.4747269 262.470211 38.0658412 262.470211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-250",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "14.991697 266.342025 24.401748 266.342025 24.401748 262.470211 14.991697 262.470211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-251",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 288.197815 51.9679534 288.197815 51.9679534 283.408303 49.9437728 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-252",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 288.197815 55.421413 288.197815 55.421413 283.408303 53.3954843 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-253",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 288.197815 43.2906045 288.197815 43.2906045 283.408303 41.2655499 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-254",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 288.197815 46.7440641 288.197815 46.7440641 283.408303 44.7190095 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-255",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 288.197815 34.6103423 288.197815 34.6103423 283.408303 32.5879097 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-256",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 288.197815 38.0658412 288.197815 38.0658412 283.408303 36.0402039 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-257",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 288.197815 25.9329934 288.197815 25.9329934 283.408303 23.9091042 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-258",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 288.197815 29.388201 288.197815 29.388201 283.408303 27.3616897 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-259",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 288.197815 17.2541879 288.197815 17.2541879 283.408303 15.2291333 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-260",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 288.197815 20.7093955 288.197815 20.7093955 283.408303 18.6817189 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-261",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 288.197815 8.57596504 288.197815 8.57596504 283.408303 6.55091042 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-262",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 288.197815 12.0294246 288.197815 12.0294246 283.408303 10.005244 283.408303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-263",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 281.928332 51.9679534 281.928332 51.9679534 277.13882 49.9437728 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-264",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 281.928332 55.421413 281.928332 55.421413 277.13882 53.3954843 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-265",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 281.928332 43.2906045 281.928332 43.2906045 277.13882 41.2655499 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-266",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 281.928332 46.7440641 281.928332 46.7440641 277.13882 44.7190095 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-267",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 281.928332 34.6103423 281.928332 34.6103423 277.13882 32.5879097 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-268",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 281.928332 38.0658412 281.928332 38.0658412 277.13882 36.0402039 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-269",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 281.928332 25.9329934 281.928332 25.9329934 277.13882 23.9091042 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-270",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 281.928332 29.388201 281.928332 29.388201 277.13882 27.3616897 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-271",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 281.928332 17.2541879 281.928332 17.2541879 277.13882 15.2291333 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-272",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 281.928332 20.7093955 281.928332 20.7093955 277.13882 18.6817189 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-273",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 281.928332 8.57596504 281.928332 8.57596504 277.13882 6.55091042 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-274",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 281.928332 12.0294246 281.928332 12.0294246 277.13882 10.005244 277.13882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-275",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "-1.24202663e-14 291.792862 62.2621996 291.792862 62.2621996 290.411945 -1.24202663e-14 290.411945"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-276",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 305.753532 51.9679534 305.753532 51.9679534 300.966934 49.9437728 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-277",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 305.753532 55.421413 305.753532 55.421413 300.966934 53.3954843 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-278",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 305.753532 43.2906045 305.753532 43.2906045 300.966934 41.2655499 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-279",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 305.753532 46.7440641 305.753532 46.7440641 300.966934 44.7190095 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-280",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 305.753532 34.6103423 305.753532 34.6103423 300.966934 32.5879097 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-281",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 305.753532 38.0658412 305.753532 38.0658412 300.966934 36.0402039 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-282",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 305.753532 25.9329934 305.753532 25.9329934 300.966934 23.9091042 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-283",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 305.753532 29.388201 305.753532 29.388201 300.966934 27.3616897 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-284",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 305.753532 17.2541879 305.753532 17.2541879 300.966934 15.2291333 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-285",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 305.753532 20.7093955 305.753532 20.7093955 300.966934 18.6817189 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-286",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 305.753532 8.57596504 305.753532 8.57596504 300.966934 6.55091042 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-287",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 305.753532 12.0294246 305.753532 12.0294246 300.966934 10.005244 300.966934"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-288",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 299.48405 51.9679534 299.48405 51.9679534 294.694538 49.9437728 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-289",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 299.48405 55.421413 299.48405 55.421413 294.694538 53.3954843 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-290",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 299.48405 43.2906045 299.48405 43.2906045 294.694538 41.2655499 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-291",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 299.48405 46.7440641 299.48405 46.7440641 294.694538 44.7190095 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-292",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 299.48405 34.6103423 299.48405 34.6103423 294.694538 32.5879097 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-293",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 299.48405 38.0658412 299.48405 38.0658412 294.694538 36.0402039 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-294",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 299.48405 25.9329934 299.48405 25.9329934 294.694538 23.9091042 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-295",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 299.48405 29.388201 299.48405 29.388201 294.694538 27.3616897 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-296",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 299.48405 17.2541879 299.48405 17.2541879 294.694538 15.2291333 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-297",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 299.48405 20.7093955 299.48405 20.7093955 294.694538 18.6817189 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-298",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 299.48405 8.57596504 299.48405 8.57596504 294.694538 6.55091042 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-299",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 299.48405 12.0294246 299.48405 12.0294246 294.694538 10.005244 294.694538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-300",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "-1.24202663e-14 309.351493 62.2621996 309.351493 62.2621996 307.967662 -1.24202663e-14 307.967662"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-301",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 323.312163 51.9679534 323.312163 51.9679534 318.522651 49.9437728 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-302",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 323.312163 55.421413 323.312163 55.421413 318.522651 53.3954843 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-303",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 323.312163 43.2906045 323.312163 43.2906045 318.522651 41.2655499 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-304",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 323.312163 46.7440641 323.312163 46.7440641 318.522651 44.7190095 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-305",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 323.312163 34.6103423 323.312163 34.6103423 318.522651 32.5879097 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-306",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 323.312163 38.0658412 323.312163 38.0658412 318.522651 36.0402039 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-307",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 323.312163 25.9329934 323.312163 25.9329934 318.522651 23.9091042 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-308",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 323.312163 29.388201 323.312163 29.388201 318.522651 27.3616897 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-309",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 323.312163 17.2541879 323.312163 17.2541879 318.522651 15.2291333 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-310",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 323.312163 20.7093955 323.312163 20.7093955 318.522651 18.6817189 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-311",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 323.312163 8.57596504 323.312163 8.57596504 318.522651 6.55091042 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-312",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 323.312163 12.0294246 323.312163 12.0294246 318.522651 10.005244 318.522651"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-313",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 317.04268 51.9679534 317.04268 51.9679534 312.253168 49.9437728 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-314",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 317.04268 55.421413 317.04268 55.421413 312.253168 53.3954843 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-315",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 317.04268 43.2906045 317.04268 43.2906045 312.253168 41.2655499 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-316",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 317.04268 46.7440641 317.04268 46.7440641 312.253168 44.7190095 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-317",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 317.04268 34.6103423 317.04268 34.6103423 312.253168 32.5879097 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-318",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 317.04268 38.0658412 317.04268 38.0658412 312.253168 36.0402039 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-319",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 317.04268 25.9329934 317.04268 25.9329934 312.253168 23.9091042 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-320",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 317.04268 29.388201 317.04268 29.388201 312.253168 27.3616897 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-321",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 317.04268 17.2541879 317.04268 17.2541879 312.253168 15.2291333 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-322",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 317.04268 20.7093955 317.04268 20.7093955 312.253168 18.6817189 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-323",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 317.04268 8.57596504 317.04268 8.57596504 312.253168 6.55091042 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-324",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 317.04268 12.0294246 317.04268 12.0294246 312.253168 10.005244 312.253168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-325",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "-1.24202663e-14 326.910124 62.2621996 326.910124 62.2621996 325.526293 -1.24202663e-14 325.526293"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-326",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 340.870794 51.9679534 340.870794 51.9679534 336.081282 49.9437728 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-327",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 340.870794 55.421413 340.870794 55.421413 336.081282 53.3954843 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-328",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 340.870794 43.2906045 340.870794 43.2906045 336.081282 41.2655499 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-329",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 340.870794 46.7440641 340.870794 46.7440641 336.081282 44.7190095 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-330",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 340.870794 34.6103423 340.870794 34.6103423 336.081282 32.5879097 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-331",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 340.870794 38.0658412 340.870794 38.0658412 336.081282 36.0402039 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-332",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 340.870794 25.9329934 340.870794 25.9329934 336.081282 23.9091042 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-333",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 340.870794 29.388201 340.870794 29.388201 336.081282 27.3616897 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-334",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 340.870794 17.2541879 340.870794 17.2541879 336.081282 15.2291333 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-335",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 340.870794 20.7093955 340.870794 20.7093955 336.081282 18.6817189 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-336",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 340.870794 8.57596504 340.870794 8.57596504 336.081282 6.55091042 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-337",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 340.870794 12.0294246 340.870794 12.0294246 336.081282 10.005244 336.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-338",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 334.601311 51.9679534 334.601311 51.9679534 329.811799 49.9437728 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-339",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 334.601311 55.421413 334.601311 55.421413 329.811799 53.3954843 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-340",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 334.601311 43.2906045 334.601311 43.2906045 329.811799 41.2655499 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-341",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 334.601311 46.7440641 334.601311 46.7440641 329.811799 44.7190095 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-342",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 334.601311 34.6103423 334.601311 34.6103423 329.811799 32.5879097 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-343",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 334.601311 38.0658412 334.601311 38.0658412 329.811799 36.0402039 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-344",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 334.601311 25.9329934 334.601311 25.9329934 329.811799 23.9091042 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-345",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 334.601311 29.388201 334.601311 29.388201 329.811799 27.3616897 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-346",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 334.601311 17.2541879 334.601311 17.2541879 329.811799 15.2291333 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-347",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 334.601311 20.7093955 334.601311 20.7093955 329.811799 18.6817189 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-348",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 334.601311 8.57596504 334.601311 8.57596504 329.811799 6.55091042 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-349",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 334.601311 12.0294246 334.601311 12.0294246 329.811799 10.005244 329.811799"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-350",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "-1.24202663e-14 344.465841 62.2621996 344.465841 62.2621996 343.084924 -1.24202663e-14 343.084924"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-351",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 358.426511 51.9679534 358.426511 51.9679534 353.639913 49.9437728 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-352",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 358.426511 55.421413 358.426511 55.421413 353.639913 53.3954843 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-353",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 358.426511 43.2906045 358.426511 43.2906045 353.639913 41.2655499 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-354",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 358.426511 46.7440641 358.426511 46.7440641 353.639913 44.7190095 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-355",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 358.426511 34.6103423 358.426511 34.6103423 353.639913 32.5879097 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-356",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 358.426511 38.0658412 358.426511 38.0658412 353.639913 36.0402039 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-357",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 358.426511 25.9329934 358.426511 25.9329934 353.639913 23.9091042 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-358",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 358.426511 29.388201 358.426511 29.388201 353.639913 27.3616897 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-359",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 358.426511 17.2541879 358.426511 17.2541879 353.639913 15.2291333 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-360",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 358.426511 20.7093955 358.426511 20.7093955 353.639913 18.6817189 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-361",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 358.426511 8.57596504 358.426511 8.57596504 353.639913 6.55091042 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-362",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 358.426511 12.0294246 358.426511 12.0294246 353.639913 10.005244 353.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-363",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 352.157028 51.9679534 352.157028 51.9679534 347.367516 49.9437728 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-364",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 352.157028 55.421413 352.157028 55.421413 347.367516 53.3954843 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-365",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 352.157028 43.2906045 352.157028 43.2906045 347.367516 41.2655499 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-366",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 352.157028 46.7440641 352.157028 46.7440641 347.367516 44.7190095 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-367",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 352.157028 34.6103423 352.157028 34.6103423 347.367516 32.5879097 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-368",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 352.157028 38.0658412 352.157028 38.0658412 347.367516 36.0402039 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-369",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 352.157028 25.9329934 352.157028 25.9329934 347.367516 23.9091042 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-370",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 352.157028 29.388201 352.157028 29.388201 347.367516 27.3616897 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-371",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 352.157028 17.2541879 352.157028 17.2541879 347.367516 15.2291333 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-372",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 352.157028 20.7093955 352.157028 20.7093955 347.367516 18.6817189 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-373",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 352.157028 8.57596504 352.157028 8.57596504 347.367516 6.55091042 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-374",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 352.157028 12.0294246 352.157028 12.0294246 347.367516 10.005244 347.367516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-375",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "-1.24202663e-14 362.024472 62.2621996 362.024472 62.2621996 360.640641 -1.24202663e-14 360.640641"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-376",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 375.988055 51.9679534 375.988055 51.9679534 371.19563 49.9437728 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-377",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 375.988055 55.421413 375.988055 55.421413 371.19563 53.3954843 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-378",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 375.988055 43.2906045 375.988055 43.2906045 371.19563 41.2655499 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-379",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 375.988055 46.7440641 375.988055 46.7440641 371.19563 44.7190095 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-380",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 375.988055 34.6103423 375.988055 34.6103423 371.19563 32.5879097 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-381",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 375.988055 38.0658412 375.988055 38.0658412 371.19563 36.0402039 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-382",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 375.988055 25.9329934 375.988055 25.9329934 371.19563 23.9091042 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-383",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 375.988055 29.388201 375.988055 29.388201 371.19563 27.3616897 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-384",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 375.988055 17.2541879 375.988055 17.2541879 371.19563 15.2291333 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-385",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 375.988055 20.7093955 375.988055 20.7093955 371.19563 18.6817189 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-386",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 375.988055 8.57596504 375.988055 8.57596504 371.19563 6.55091042 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-387",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 375.988055 12.0294246 375.988055 12.0294246 371.19563 10.005244 371.19563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-388",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 369.715659 51.9679534 369.715659 51.9679534 364.926147 49.9437728 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-389",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 369.715659 55.421413 369.715659 55.421413 364.926147 53.3954843 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-390",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 369.715659 43.2906045 369.715659 43.2906045 364.926147 41.2655499 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-391",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 369.715659 46.7440641 369.715659 46.7440641 364.926147 44.7190095 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-392",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 369.715659 34.6103423 369.715659 34.6103423 364.926147 32.5879097 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-393",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 369.715659 38.0658412 369.715659 38.0658412 364.926147 36.0402039 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-394",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 369.715659 25.9329934 369.715659 25.9329934 364.926147 23.9091042 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-395",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 369.715659 29.388201 369.715659 29.388201 364.926147 27.3616897 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-396",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 369.715659 17.2541879 369.715659 17.2541879 364.926147 15.2291333 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-397",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 369.715659 20.7093955 369.715659 20.7093955 364.926147 18.6817189 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-398",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 369.715659 8.57596504 369.715659 8.57596504 364.926147 6.55091042 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-399",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 369.715659 12.0294246 369.715659 12.0294246 364.926147 10.005244 364.926147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-400",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "-1.24202663e-14 379.583103 62.2621996 379.583103 62.2621996 378.199272 -1.24202663e-14 378.199272"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-401",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 387.667589 51.9679534 387.667589 51.9679534 382.878077 49.9437728 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-402",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 387.667589 55.421413 387.667589 55.421413 382.878077 53.3954843 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-403",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "41.2655499 387.667589 43.2906045 387.667589 43.2906045 382.878077 41.2655499 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-404",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "44.7190095 387.667589 46.7440641 387.667589 46.7440641 382.878077 44.7190095 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-405",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "32.5879097 387.667589 34.6103423 387.667589 34.6103423 382.878077 32.5879097 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-406",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "36.0402039 387.667589 38.0658412 387.667589 38.0658412 382.878077 36.0402039 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-407",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "23.9091042 387.667589 25.9329934 387.667589 25.9329934 382.878077 23.9091042 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-408",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "27.3616897 387.667589 29.388201 387.667589 29.388201 382.878077 27.3616897 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-409",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "15.2291333 387.667589 17.2541879 387.667589 17.2541879 382.878077 15.2291333 382.878077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2655499,398.732411 L46.7440641,398.732411 L46.7440641,392.378441 C46.7440641,390.866424 45.5184268,389.639913 44.0049527,389.639913 C42.4908958,389.639913 41.2655499,390.866424 41.2655499,392.378441 L41.2655499,398.732411",
    id: "Fill-410",
    fill: "#444646",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5879097,398.732411 L38.0658412,398.732411 L38.0658412,392.381355 C38.0658412,390.866424 36.8393299,389.639913 35.3273125,389.639913 C33.812673,389.639913 32.5879097,390.866424 32.5879097,392.381355 L32.5879097,398.732411",
    id: "Fill-411",
    fill: "#444646",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9091042,398.732411 L29.388201,398.732411 L29.388201,392.381355 C29.388201,390.866424 28.1608157,389.639913 26.6482156,389.639913 C25.1356154,389.639913 23.9091042,390.866424 23.9091042,392.381355 L23.9091042,398.732411",
    id: "Fill-412",
    fill: "#444646",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2308813,398.732411 L20.7093955,398.732411 L20.7093955,392.378441 C20.7093955,390.866424 19.4823015,389.639913 17.9699927,389.639913 C16.4571012,389.639913 15.2308813,390.866424 15.2308813,392.378441 L15.2308813,398.732411",
    id: "Fill-413",
    fill: "#444646",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-414",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "18.6817189 387.667589 20.7093955 387.667589 20.7093955 382.878077 18.6817189 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-415",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 387.667589 8.57596504 387.667589 8.57596504 382.878077 6.55091042 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-416",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 387.667589 12.0294246 387.667589 12.0294246 382.878077 10.005244 382.878077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-417",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "49.9437728 394.429425 51.9679534 394.429425 51.9679534 389.639913 49.9437728 389.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-418",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "53.3954843 394.429425 55.421413 394.429425 55.421413 389.639913 53.3954843 389.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-419",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "6.55091042 394.429425 8.57596504 394.429425 8.57596504 389.639913 6.55091042 389.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-420",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "10.005244 394.429425 12.0294246 394.429425 12.0294246 389.639913 10.005244 389.639913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-421",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "1064.41078 399.999709 1130.07138 399.999709 1130.07138 287.775382 1064.41078 287.775382"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-422",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "1074.47342 287.775382 1120.01165 287.775382 1120.01165 277.465113 1074.47342 277.465113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-423",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1116.7429 306.988784 1121.80626 306.988784 1121.80626 297.316533 1116.7429 297.316533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-424",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1105.94902 306.988784 1111.00655 306.988784 1111.00655 297.316533 1105.94902 297.316533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-425",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1095.14639 306.988784 1100.20685 306.988784 1100.20685 297.316533 1095.14639 297.316533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-426",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1084.34669 306.988784 1089.41005 306.988784 1089.41005 297.316533 1084.34669 297.316533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-427",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1073.54698 306.988784 1078.61034 306.988784 1078.61034 297.316533 1073.54698 297.316533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-428",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1116.7429 324.678514 1121.80626 324.678514 1121.80626 315.009177 1116.7429 315.009177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-429",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1105.94902 324.678514 1111.00655 324.678514 1111.00655 315.009177 1105.94902 315.009177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-430",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1095.14639 324.678514 1100.20685 324.678514 1100.20685 315.009177 1095.14639 315.009177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-431",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1084.34669 324.678514 1089.41005 324.678514 1089.41005 315.009177 1084.34669 315.009177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-432",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1073.54698 324.678514 1078.61034 324.678514 1078.61034 315.009177 1073.54698 315.009177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-433",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1116.7429 342.368245 1121.80626 342.368245 1121.80626 332.695994 1116.7429 332.695994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-434",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1105.94902 342.368245 1111.00655 342.368245 1111.00655 332.695994 1105.94902 332.695994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-435",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1095.14639 342.368245 1100.20685 342.368245 1100.20685 332.695994 1095.14639 332.695994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-436",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1084.34669 342.368245 1089.41005 342.368245 1089.41005 332.695994 1084.34669 332.695994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-437",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1073.54698 342.368245 1078.61034 342.368245 1078.61034 332.695994 1073.54698 332.695994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-438",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1116.7429 360.057975 1121.80626 360.057975 1121.80626 350.388638 1116.7429 350.388638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-439",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1105.94902 360.057975 1111.00655 360.057975 1111.00655 350.388638 1105.94902 350.388638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-440",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1095.14639 360.057975 1100.20685 360.057975 1100.20685 350.388638 1095.14639 350.388638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-441",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1084.34669 360.057975 1089.41005 360.057975 1089.41005 350.388638 1084.34669 350.388638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-442",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1073.54698 360.057975 1078.61034 360.057975 1078.61034 350.388638 1073.54698 350.388638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-443",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1116.7429 377.750619 1121.80626 377.750619 1121.80626 368.081282 1116.7429 368.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-444",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1105.94902 377.750619 1111.00655 377.750619 1111.00655 368.081282 1105.94902 368.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-445",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1095.14639 377.750619 1100.20685 377.750619 1100.20685 368.081282 1095.14639 368.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-446",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1084.34669 377.750619 1089.41005 377.750619 1089.41005 368.081282 1084.34669 368.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-447",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "1073.54698 377.750619 1078.61034 377.750619 1078.61034 368.081282 1073.54698 368.081282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-448",
    fill: "#F5F5F6",
    mask: "url(#mask-2)",
    points: "1073.54698 399.999709 1121.80626 399.999709 1121.80626 385.954552 1073.54698 385.954552"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-449",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "493.648944 260.867881 512.932265 260.867881 527.580481 286.152658 493.648944 286.152658 493.648944 260.867881"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-450",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "493.648944 260.867881 512.932265 260.867881 527.580481 286.152658 508.29716 286.152658 493.648944 260.867881"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-451",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "527.580481 309.537946 531.350328 309.537946 531.350328 302.085652 527.580481 302.085652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-452",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "527.580481 325.47094 531.350328 325.47094 531.350328 318.018645 527.580481 318.018645"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-453",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "527.580481 341.403933 531.350328 341.403933 531.350328 333.951639 527.580481 333.951639"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-454",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "527.580481 357.336926 531.350328 357.336926 531.350328 349.884632 527.580481 349.884632"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-455",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "527.580481 373.26992 531.350328 373.26992 531.350328 365.814712 527.580481 365.814712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.324108,309.537946 L523.096868,309.537946 L523.096868,302.085652 L519.324108,302.085652 L519.324108,309.537946 Z M519.324108,325.47094 L523.096868,325.47094 L523.096868,318.018645 L519.324108,318.018645 L519.324108,325.47094 Z M519.324108,341.403933 L523.096868,341.403933 L523.096868,333.951639 L519.324108,333.951639 L519.324108,341.403933 Z M519.324108,357.336926 L523.096868,357.336926 L523.096868,349.884632 L519.324108,349.884632 L519.324108,357.336926 Z M519.324108,373.26992 L523.096868,373.26992 L523.096868,365.814712 L519.324108,365.814712 L519.324108,373.26992 Z M519.324108,389.202913 L523.096868,389.202913 L523.096868,381.747706 L519.324108,381.747706 L519.324108,389.202913 Z M511.070648,309.537946 L514.843409,309.537946 L514.843409,302.085652 L511.070648,302.085652 L511.070648,309.537946 Z M511.070648,325.47094 L514.843409,325.47094 L514.843409,318.018645 L511.070648,318.018645 L511.070648,325.47094 Z M511.070648,341.403933 L514.843409,341.403933 L514.843409,333.951639 L511.070648,333.951639 L511.070648,341.403933 Z M511.070648,357.336926 L514.843409,357.336926 L514.843409,349.884632 L511.070648,349.884632 L511.070648,357.336926 Z M511.070648,373.26992 L514.843409,373.26992 L514.843409,365.814712 L511.070648,365.814712 L511.070648,373.26992 Z M511.070648,389.202913 L514.843409,389.202913 L514.843409,381.747706 L511.070648,381.747706 L511.070648,389.202913 Z M493.648944,400.017189 L527.580481,400.017189 L527.580481,286.152658 L493.648944,286.152658 L493.648944,400.017189 Z",
    id: "Fill-456",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.42724,363.871522 L114.3126,363.871522 L114.3126,359.460743 L109.42724,359.460743 L109.42724,363.871522 Z M109.42724,378.642098 L114.311143,378.642098 L114.311143,374.228405 L109.42724,374.228405 L109.42724,378.642098 Z M100.954115,378.642098 L105.83831,378.642098 L105.83831,374.228405 L100.954115,374.228405 L100.954115,378.642098 Z M92.4804079,363.871522 L97.3646031,363.871522 L97.3646031,359.460743 L92.4804079,359.460743 L92.4804079,363.871522 Z M92.4804079,378.642098 L97.3646031,378.642098 L97.3646031,374.228405 L92.4804079,374.228405 L92.4804079,378.642098 Z M84.0064093,363.871522 L88.8908958,363.871522 L88.8908958,359.460743 L84.0064093,359.460743 L84.0064093,363.871522 Z M84.0064093,378.642098 L88.8908958,378.642098 L88.8908958,374.228405 L84.0064093,374.228405 L84.0064093,378.642098 Z M72.1290605,400.017189 L125.127167,400.017189 L125.127167,345.858412 L72.1290605,345.858412 L72.1290605,400.017189 Z",
    id: "Fill-457",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.337946,375.647196 L480.655499,375.647196 L480.655499,370.257538 L476.337946,370.257538 L476.337946,375.647196 Z M476.337946,384.669774 L480.655499,384.669774 L480.655499,379.277203 L476.337946,379.277203 L476.337946,384.669774 Z M461.363438,375.647196 L465.678077,375.647196 L465.678077,370.257538 L461.363438,370.257538 L461.363438,375.647196 Z M453.87327,375.647196 L458.18791,375.647196 L458.18791,370.257538 L453.87327,370.257538 L453.87327,375.647196 Z M446.388929,375.647196 L450.700655,375.647196 L450.700655,370.257538 L446.388929,370.257538 L446.388929,375.647196 Z M442.316096,400.017189 L484.206846,400.017189 L484.206846,363.658849 L442.316096,363.658849 L442.316096,400.017189 Z",
    id: "Fill-458",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-459",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "343.848507 234.452731 460.180626 234.452731 460.180626 230.356591 343.848507 230.356591"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-460",
    fill: "#54274B",
    mask: "url(#mask-2)",
    points: "343.848507 234.452731 343.848507 244.614421 361.756737 244.614421 361.756737 240.518281 442.272396 240.518281 442.272396 244.614421 460.180626 244.614421 460.180626 234.452731 343.848507 234.452731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.920612,253.40102 L448.381646,253.40102 L448.381646,246.560524 L444.920612,246.560524 L444.920612,253.40102 Z M444.920612,268.017189 L448.381646,268.017189 L448.381646,261.179607 L444.920612,261.179607 L444.920612,268.017189 Z M444.920612,282.636271 L448.381646,282.636271 L448.381646,275.798689 L444.920612,275.798689 L444.920612,282.636271 Z M444.920612,297.25244 L448.381646,297.25244 L448.381646,290.414858 L444.920612,290.414858 L444.920612,297.25244 Z M444.920612,311.871522 L448.381646,311.871522 L448.381646,305.03394 L444.920612,305.03394 L444.920612,311.871522 Z M444.920612,326.490605 L448.381646,326.490605 L448.381646,319.650109 L444.920612,319.650109 L444.920612,326.490605 Z M444.920612,341.106773 L448.381646,341.106773 L448.381646,334.269192 L444.920612,334.269192 L444.920612,341.106773 Z M437.348871,253.40102 L440.809905,253.40102 L440.809905,246.560524 L437.348871,246.560524 L437.348871,253.40102 Z M437.348871,268.017189 L440.809905,268.017189 L440.809905,261.179607 L437.348871,261.179607 L437.348871,268.017189 Z M437.348871,282.636271 L440.809905,282.636271 L440.809905,275.798689 L437.348871,275.798689 L437.348871,282.636271 Z M437.348871,297.25244 L440.809905,297.25244 L440.809905,290.414858 L437.348871,290.414858 L437.348871,297.25244 Z M437.348871,326.490605 L440.809905,326.490605 L440.809905,319.650109 L437.348871,319.650109 L437.348871,326.490605 Z M437.348871,341.106773 L440.809905,341.106773 L440.809905,334.269192 L437.348871,334.269192 L437.348871,341.106773 Z M426.694829,253.40102 L430.15295,253.40102 L430.15295,246.560524 L426.694829,246.560524 L426.694829,253.40102 Z M426.694829,268.017189 L430.15295,268.017189 L430.15295,261.179607 L426.694829,261.179607 L426.694829,268.017189 Z M426.694829,282.636271 L430.15295,282.636271 L430.15295,275.798689 L426.694829,275.798689 L426.694829,282.636271 Z M426.694829,297.25244 L430.15295,297.25244 L430.15295,290.414858 L426.694829,290.414858 L426.694829,297.25244 Z M426.694829,311.871522 L430.15295,311.871522 L430.15295,305.03394 L426.694829,305.03394 L426.694829,311.871522 Z M426.694829,326.490605 L430.15295,326.490605 L430.15295,319.650109 L426.694829,319.650109 L426.694829,326.490605 Z M419.120175,253.40102 L422.581209,253.40102 L422.581209,246.560524 L419.120175,246.560524 L419.120175,253.40102 Z M419.120175,268.017189 L422.581209,268.017189 L422.581209,261.179607 L419.120175,261.179607 L419.120175,268.017189 Z M419.120175,297.25244 L422.581209,297.25244 L422.581209,290.414858 L419.120175,290.414858 L419.120175,297.25244 Z M419.120175,311.871522 L422.581209,311.871522 L422.581209,305.03394 L419.120175,305.03394 L419.120175,311.871522 Z M381.817917,253.40102 L385.276038,253.40102 L385.276038,246.560524 L381.817917,246.560524 L381.817917,253.40102 Z M381.817917,268.017189 L385.276038,268.017189 L385.276038,261.179607 L381.817917,261.179607 L381.817917,268.017189 Z M374.243263,253.40102 L377.704297,253.40102 L377.704297,246.560524 L374.243263,246.560524 L374.243263,253.40102 Z M374.243263,282.636271 L377.704297,282.636271 L377.704297,275.798689 L374.243263,275.798689 L374.243263,282.636271 Z M363.589221,253.40102 L367.050255,253.40102 L367.050255,246.560524 L363.589221,246.560524 L363.589221,253.40102 Z M363.589221,268.017189 L367.050255,268.017189 L367.050255,261.179607 L363.589221,261.179607 L363.589221,268.017189 Z M363.589221,297.25244 L367.050255,297.25244 L367.050255,290.414858 L363.589221,290.414858 L363.589221,297.25244 Z M356.014567,253.40102 L359.475601,253.40102 L359.475601,246.560524 L356.014567,246.560524 L356.014567,253.40102 Z M356.014567,268.017189 L359.475601,268.017189 L359.475601,261.179607 L356.014567,261.179607 L356.014567,268.017189 Z M343.848507,400.017189 L460.180626,400.017189 L460.180626,232.346395 L343.848507,232.346395 L343.848507,400.017189 Z",
    id: "Fill-461",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-462",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "351.420248 230.356591 379.647487 230.356591 379.647487 219.973489 351.420248 219.973489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-463",
    fill: "#F5F5F6",
    mask: "url(#mask-2)",
    points: "353.972323 225.05142 356.541879 225.05142 356.541879 219.973489 353.972323 219.973489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-464",
    fill: "#F5F5F6",
    mask: "url(#mask-2)",
    points: "359.111435 225.05142 361.680991 225.05142 361.680991 219.973489 359.111435 219.973489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-465",
    fill: "#F5F5F6",
    mask: "url(#mask-2)",
    points: "364.247633 225.05142 366.817189 225.05142 366.817189 219.973489 364.247633 219.973489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-466",
    fill: "#F5F5F6",
    mask: "url(#mask-2)",
    points: "369.386744 225.05142 371.9563 225.05142 371.9563 219.973489 369.386744 219.973489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-467",
    fill: "#F5F5F6",
    mask: "url(#mask-2)",
    points: "374.525856 225.05142 377.095412 225.05142 377.095412 219.973489 374.525856 219.973489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-468",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "351.420248 219.973489 379.647487 219.973489 379.647487 216.124982 351.420248 216.124982"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-469",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "357.745084 216.124982 358.327749 216.124982 358.327749 197.657393 357.745084 197.657393"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-470",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "365.028405 216.124982 365.611071 216.124982 365.611071 204.151202 365.028405 204.151202"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-471",
    fill: "#F5F5F6",
    mask: "url(#mask-2)",
    points: "978.447196 389.38354 1047.01821 389.38354 1047.01821 327.09949 978.447196 327.09949"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-472",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "970.010197 394.703277 1055.45229 394.703277 1055.45229 389.386453 970.010197 389.386453"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-473",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "965.366351 399.999709 1060.09614 399.999709 1060.09614 394.703277 965.366351 394.703277"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-474",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "991.335761 385.205827 999.84268 385.205827 998.482156 331.915222 992.696286 331.915222 991.335761 385.205827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.44428,387.294683 C1002.44428,388.451275 1001.50619,389.386453 1000.35251,389.386453 L990.825929,389.386453 C989.672251,389.386453 988.737072,388.451275 988.737072,387.297597 C988.737072,386.141005 989.672251,385.202913 990.828842,385.202913 L1000.35251,385.202913 C1001.50619,385.202913 1002.44428,386.141005 1002.44428,387.294683",
    id: "Fill-475",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-476",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "974.193736 385.205827 982.700655 385.205827 981.340131 331.915222 975.554261 331.915222 974.193736 385.205827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.302258,387.294683 C985.302258,388.451275 984.364166,389.386453 983.210488,389.386453 L973.683904,389.386453 C972.530226,389.386453 971.592134,388.451275 971.592134,387.297597 C971.592134,386.141005 972.530226,385.202913 973.683904,385.202913 L983.210488,385.202913 C984.364166,385.202913 985.302258,386.141005 985.302258,387.294683",
    id: "Fill-477",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-478",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "1008.47779 385.205827 1016.98471 385.205827 1015.62127 331.915222 1009.83831 331.915222 1008.47779 385.205827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.58631,387.294683 C1019.58631,388.451275 1018.64822,389.386453 1017.49454,389.386453 L1007.97087,389.386453 C1006.81428,389.386453 1005.8791,388.451275 1005.8791,387.294683 C1005.8791,386.141005 1006.81428,385.205827 1007.97087,385.205827 L1017.49454,385.205827 C1018.64822,385.205827 1019.58631,386.141005 1019.58631,387.294683",
    id: "Fill-479",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-480",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "1025.61981 385.205827 1034.12673 385.205827 1032.76621 331.915222 1026.98034 331.915222 1025.61981 385.205827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.72833,387.297597 C1036.72833,388.451275 1035.79315,389.386453 1034.63656,389.386453 L1025.11289,389.386453 C1023.9563,389.386453 1023.02112,388.451275 1023.02112,387.297597 C1023.02112,386.141005 1023.9563,385.205827 1025.11289,385.205827 L1034.63656,385.205827 C1035.79315,385.205827 1036.72833,386.141005 1036.72833,387.297597",
    id: "Fill-481",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-482",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "1042.76475 385.205827 1051.26875 385.205827 1049.90823 331.915222 1044.12236 331.915222 1042.76475 385.205827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.87036,387.294683 C1053.87036,388.451275 1052.93518,389.386453 1051.77859,389.386453 L1042.25492,389.386453 C1041.10124,389.386453 1040.16315,388.451275 1040.16315,387.294683 C1040.16315,386.141005 1041.10124,385.205827 1042.25492,385.205827 L1051.77859,385.205827 C1052.93518,385.205827 1053.87036,386.141005 1053.87036,387.294683",
    id: "Fill-483",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.73125,324.838747 C1009.38092,324.838747 1006.66278,322.120612 1006.66278,318.770284 C1006.66278,315.419956 1009.38092,312.701821 1012.73125,312.701821 C1016.08449,312.701821 1018.79971,315.419956 1018.79971,318.770284 C1018.79971,322.120612 1016.08449,324.838747 1012.73125,324.838747 Z M1055.99126,327.09949 L1012.73125,307.280117 L969.471231,327.09949 L969.471231,331.915222 L1055.99126,331.915222 L1055.99126,327.09949 L1055.99126,327.09949 Z",
    id: "Fill-484",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-485",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "913.418791 399.999709 954.388929 399.999709 954.388929 296.658121 913.418791 296.658121"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-486",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "919.697014 296.658121 948.107793 296.658121 948.107793 287.163583 919.697014 287.163583"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-487",
    fill: "#F5F5F6",
    mask: "url(#mask-2)",
    points: "918.578296 399.999709 948.687546 399.999709 948.687546 387.067444 918.578296 387.067444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-488",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 310.152658 926.383103 310.152658 926.383103 305.447633 915.128915 305.447633"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-489",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 318.761544 926.383103 318.761544 926.383103 314.053605 915.128915 314.053605"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-490",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 327.37043 926.383103 327.37043 926.383103 322.665404 915.128915 322.665404"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-491",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 335.979315 926.383103 335.979315 926.383103 331.271377 915.128915 331.271377"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-492",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 344.588201 926.383103 344.588201 926.383103 339.883176 915.128915 339.883176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-493",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 310.152658 939.530954 310.152658 939.530954 305.447633 928.276766 305.447633"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-494",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 318.761544 939.530954 318.761544 939.530954 314.053605 928.276766 314.053605"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-495",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 327.37043 939.530954 327.37043 939.530954 322.665404 928.276766 322.665404"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-496",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 335.979315 939.530954 335.979315 939.530954 331.271377 928.276766 331.271377"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-497",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 344.588201 939.530954 344.588201 939.530954 339.883176 928.276766 339.883176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-498",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 310.152658 952.678806 310.152658 952.678806 305.447633 941.424618 305.447633"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-499",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 318.761544 952.678806 318.761544 952.678806 314.053605 941.424618 314.053605"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-500",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 327.37043 952.678806 327.37043 952.678806 322.665404 941.424618 322.665404"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-501",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 335.979315 952.678806 335.979315 952.678806 331.271377 941.424618 331.271377"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-502",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 344.588201 952.678806 344.588201 952.678806 339.883176 941.424618 339.883176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-503",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 353.197087 926.383103 353.197087 926.383103 348.489148 915.128915 348.489148"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-504",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 361.805972 926.383103 361.805972 926.383103 357.100947 915.128915 357.100947"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-505",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 370.414858 926.383103 370.414858 926.383103 365.706919 915.128915 365.706919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-506",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "915.128915 379.023744 926.383103 379.023744 926.383103 374.318718 915.128915 374.318718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-507",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 353.197087 939.530954 353.197087 939.530954 348.489148 928.276766 348.489148"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-508",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 361.805972 939.530954 361.805972 939.530954 357.100947 928.276766 357.100947"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-509",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 370.414858 939.530954 370.414858 939.530954 365.706919 928.276766 365.706919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-510",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "928.276766 379.023744 939.530954 379.023744 939.530954 374.318718 928.276766 374.318718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-511",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 353.197087 952.678806 353.197087 952.678806 348.489148 941.424618 348.489148"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-512",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 361.805972 952.678806 361.805972 952.678806 357.100947 941.424618 357.100947"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-513",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 370.414858 952.678806 370.414858 952.678806 365.706919 941.424618 365.706919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-514",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "941.424618 379.023744 952.678806 379.023744 952.678806 374.318718 941.424618 374.318718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.84268,355.795776 L373.82083,355.795776 L373.82083,350.397378 L367.84268,350.397378 L367.84268,355.795776 Z M367.84268,373.864239 L373.817917,373.864239 L373.817917,368.465841 L367.84268,368.465841 L367.84268,373.864239 Z M357.477058,373.864239 L363.452294,373.864239 L363.452294,368.465841 L357.477058,368.465841 L357.477058,373.864239 Z M347.111435,355.795776 L353.083758,355.795776 L353.083758,350.397378 L347.111435,350.397378 L347.111435,355.795776 Z M347.111435,373.864239 L353.083758,373.864239 L353.083758,368.465841 L347.111435,368.465841 L347.111435,373.864239 Z M336.742899,355.795776 L342.718135,355.795776 L342.718135,350.397378 L336.742899,350.397378 L336.742899,355.795776 Z M336.742899,373.864239 L342.718135,373.864239 L342.718135,368.465841 L336.742899,368.465841 L336.742899,373.864239 Z M331.889294,400.017189 L378.624909,400.017189 L378.624909,332.334741 L331.889294,332.334741 L331.889294,400.017189 Z",
    id: "Fill-515",
    fill: "#444646",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.09177,356.206555 L561.296431,356.206555 L561.296431,349.776839 L558.09177,349.776839 L558.09177,356.206555 Z M558.09177,370.490605 L561.296431,370.490605 L561.296431,364.063802 L558.09177,364.063802 L558.09177,370.490605 Z M552.533139,341.919592 L555.734887,341.919592 L555.734887,335.49279 L552.533139,335.49279 L552.533139,341.919592 Z M552.533139,356.206555 L555.734887,356.206555 L555.734887,349.776839 L552.533139,349.776839 L552.533139,356.206555 Z M552.533139,370.490605 L555.734887,370.490605 L555.734887,364.063802 L552.533139,364.063802 L552.533139,370.490605 Z M546.968682,341.919592 L550.176256,341.919592 L550.176256,335.49279 L546.968682,335.49279 L546.968682,341.919592 Z M546.968682,356.206555 L550.176256,356.206555 L550.176256,349.776839 L546.968682,349.776839 L546.968682,356.206555 Z M534.351056,400.017189 L568.594319,400.017189 L568.594319,327.923962 L534.351056,327.923962 L534.351056,400.017189 Z",
    id: "Fill-516",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.689731,252.693081 C553.689731,254.047779 554.788055,255.14319 556.13984,255.14319 C557.494538,255.14319 558.589949,254.047779 558.589949,252.693081 C558.589949,251.341296 557.494538,250.242972 556.13984,250.242972 C554.788055,250.242972 553.689731,251.341296 553.689731,252.693081",
    id: "Fill-517",
    fill: "#444646",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-518",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "555.172615 260.238602 557.107065 260.238602 557.107065 252.693081 555.172615 252.693081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.117261,247.268463 C547.117261,248.623161 548.215586,249.718572 549.567371,249.718572 C550.922068,249.718572 552.01748,248.623161 552.01748,247.268463 C552.01748,245.916679 550.922068,244.818354 549.567371,244.818354 C548.215586,244.818354 547.117261,245.916679 547.117261,247.268463",
    id: "Fill-519",
    fill: "#444646",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-520",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "548.600146 260.238602 550.534596 260.238602 550.534596 247.268463 548.600146 247.268463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.791697,294.187618 L564.999272,294.187618 L564.999272,287.760816 L561.791697,287.760816 L561.791697,294.187618 Z M556.233066,272.462928 L559.437728,272.462928 L559.437728,266.036125 L556.233066,266.036125 L556.233066,272.462928 Z M556.233066,294.187618 L559.437728,294.187618 L559.437728,287.760816 L556.233066,287.760816 L556.233066,294.187618 Z M550.668609,272.462928 L553.876184,272.462928 L553.876184,266.036125 L550.668609,266.036125 L550.668609,272.462928 Z M545.648944,327.923962 L568.594319,327.923962 L568.594319,260.238602 L545.648944,260.238602 L545.648944,327.923962 Z",
    id: "Fill-521",
    fill: "#E1E2E1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-522",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "846.062637 342.749891 892.145666 342.749891 892.145666 239.390823 846.062637 239.390823"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-523",
    fill: "#E1E2E1",
    mask: "url(#mask-2)",
    points: "842.613256 399.999709 895.597961 399.999709 895.597961 342.749891 842.613256 342.749891"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-524",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "852.171886 239.390823 886.03933 239.390823 886.03933 234.645011 852.171886 234.645011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-525",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "857.975237 234.645011 861.526584 234.645011 861.526584 230.368245 857.975237 230.368245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-526",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "867.329934 234.645011 870.881282 234.645011 870.881282 230.368245 867.329934 230.368245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-527",
    fill: "#444646",
    mask: "url(#mask-2)",
    points: "876.684632 234.645011 880.23598 234.645011 880.23598 230.368245 876.684632 230.368245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-528",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "852.171886 342.749891 855.723234 342.749891 855.723234 248.177422 852.171886 248.177422"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-529",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "859.749454 342.749891 863.303714 342.749891 863.303714 248.177422 859.749454 248.177422"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-530",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "867.329934 342.749891 870.881282 342.749891 870.881282 248.177422 867.329934 248.177422"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-531",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "874.907502 342.749891 878.458849 342.749891 878.458849 248.177422 874.907502 248.177422"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-532",
    fill: "#FFFFFE",
    mask: "url(#mask-2)",
    points: "882.485069 342.749891 886.03933 342.749891 886.03933 248.177422 882.485069 248.177422"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTown);
export default __webpack_public_path__ + "static/media/town.063f4086d3070af8e3ac0909bea6c955.svg";
export { ForwardRef as ReactComponent };